module.exports = __webpack_public_path__ + "img/nt20-00-75-1_1.prt.09b1063c.jpg";